import React, { useMemo } from 'react';
import ScheduledSessionsPage from './components/ScheduledSessionsPage';
import WebinarDetailPage from './components/WebinarDetailPage';
import { IUserJson } from '@scale/shared/types/user';
import { Route, Switch, useRouteMatch, useLocation } from 'react-router-dom';
import { Spinner } from '@scale/scaleui';
import { useUnleashFeatureFlagWithLoading } from 'react-scale/hooks/useUnleashFeatureFlag';
import GlobalWebinarView from 'react-scale/corp/views/CorpProjectGroupManager/apps/Webinars/views/GlobalWebinarView';
import CreateWebinarView from 'react-scale/corp/views/CorpProjectGroupManager/apps/Webinars/views/CreateWebinarView';
import EditWebinarView from 'react-scale/corp/views/CorpProjectGroupManager/apps/Webinars/views/EditWebinarView';
import { useUser } from 'react-scale/components/ui/UserContext';
interface WebinarSessionsProps {
  className?: string;
  showHeader?: boolean;
  user?: IUserJson;
  projectId?: string;
}

export const WebinarSessions: React.FC<WebinarSessionsProps> = props => {
  const match = useRouteMatch<{ projectId: string }>();
  const location = useLocation();
  const urlParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const basename = match.path.replace(/\/$/, '');
  const user = useUser();
  const { data: webinarHubFlag, isLoading } = useUnleashFeatureFlagWithLoading(
    'webinar-hub',
    { userId: user?._id },
    false,
  );

  if (isLoading) {
    return <Spinner size="lg" />;
  }

  const webinarHubEnabled = urlParams.get('webinarHub') === 'true' || webinarHubFlag;

  return (
    <>
      {webinarHubEnabled && (
        <Switch>
          <Route path={`${basename}/create`} component={CreateWebinarView} />
          <Route path={`${basename}/:id`} component={WebinarDetailPage} exact />
          <Route path={`${basename}/:id/edit`} component={EditWebinarView} exact />
          <Route
            path={basename}
            render={() => {
              return <GlobalWebinarView projectId={match.params.projectId} />;
            }}
          />
        </Switch>
      )}
      {!webinarHubEnabled && (
        <Switch>
          <Route
            path={basename}
            render={() => {
              return <ScheduledSessionsPage {...props} />;
            }}
          />
        </Switch>
      )}
    </>
  );
};
